<template>


  <div v-loading.fullscreen.lock="fullscreenLoading" class="scrollable-container">
   
    
  <!-- <div id="dqwz">
    <div class="headerbox">
      <em @click="gotoconact">联系我们</em> 
      <div class="navleftbox">
         <div class="logo" @click="gotoindexbiaoqian"><img :src="logo" /></div>
         <dl class="navdl">
             <dt @click="gotopnav(index)" :class="dqon == index ? 'active' : ''" v-for="(item,index) in mcdata" :key="index" v-if="item.state==1">{{ item.name }}</dt>
         </dl>           
      </div>
    </div>
  </div>   -->




  <div style="overflow:hidden;" class="mainbox">
    <div class="leftbox" style="position:absolute">
      <div class="leftboxmain" id="leftboxmain">
        <!-- <Anchor show-ink :offset-top="90" :scroll-offset="100">
          <AnchorLink href="dailyanli" title="推荐安利" />
          <AnchorLink v-for="(item,index) in leftnavdata" :key="index" :href="'leftclass'+index" :title="item.name" v-if="item.state==1"/> -->
  
          <!-- <AnchorLink href="#classified02" title="探索分类"/>
          <AnchorLink href="#classified03" title="探索分类"/> -->
        <!-- </Anchor> -->

        <ul :class=" istop ?'anchor-menu anchor-menutop':'anchor-menu' ">
            
            <li
              v-for="(item,index) in leftnavdata"
              :key="item.id"              
              @click.prevent="scrollTo(item.id)"
            >
              <span :class="activeId == item.id ? 'active':''">{{ item.name }}</span>
            </li>
          </ul>


      </div>
    </div>
    <div class="rightbox">
      <div class="rightmainbox">


        <div id="dailyanli" v-if="hotpicklist.length>0" ref="hotSection" class="section">

          <div class="dailyanlibox">
            <h2>{{ adarr.name }}</h2>
            <hotpick :hotpicklist="hotpicklist"></hotpick>
          </div>
        </div>

        
        <!-- <classlist  v-for="(item,index) in oslist" :key="index" :itemdata="item" v-if="item.oslist.length>0" :id="'leftclass'+index"></classlist> -->

        <div v-for="(item,index) in oslist" :key="index" v-if="item.oslist.length>0 && item.id>0" :id="item.id" class="section" ref="categorySections">
          <classlist  :itemdata="item" >{{item.id}}</classlist>
        </div> 
        
       





      </div>
    </div>

    <div class="footerbox">
        

    </div>

    
     

    </div>
  </div>
</template>

<script>
import { getmainclass,getsubclassselectos,getselectmainhotpick,getappdetail } from "@/api/api";
import hotpick from '../publish/hotpick';
import addweb from '../publish/addweb';
import classlist from '../classify/classlist';
import headernav from '../publish/headernav';
export default {
  components:{addweb,classlist,headernav,hotpick},   
  data() {
    return {
      alimg01: require("@/assets/images/webpic001.jpg"),
      alimg02: require("@/assets/images/webpic002.jpg"),
      alimg03: require("@/assets/images/webpic003.jpg"),
      alimg04: require("@/assets/images/webpic004.jpg"),
      alimg05: require("@/assets/images/tjlogo.jpg"),
      categorylist:[],
      mainindex:5,
      leftnavdata:[],
      mcdata:[],
      logo: require("@/assets/images/logo.jpg"),
      dqon:5,
      oslist:[],
      mainclassid:"", //主类id
      hotpicklist:[],
      loading: true,
      showhotcover:false,
      dqphid:"",
      fullscreenLoading: false,
      shouldCancel:false,
      activeId: 'section1',   // 当前高亮的锚点ID
      isScrolling: false,     // 是否正处于点击触发的滚动中
      scrollTimer: null,      // 滚动节流定时器
      // 配置参数
      activeId: '',   // 初始值设为空，由updateActive自动确定
      offset: 60,             // 顶部偏移量（比如固定导航栏高度）
      threshold: 100,         // 高亮切换的灵敏度阈值
      currentSectionId:'',
      istop:false,
      adarr:{
          createTime :"2026-04-09T15:20:23",
          id:"0",
          name:"热门推荐",
          page:1,
          pageSize:10,
          sortsize:98,
          state:1,
          updateTime:"2026-04-09T15:43:15"}
      
    };
  },
  created(){
    
    this.gogetmainclass();
    //window.pageYOffset = 0
     //const container = document.querySelector('.scrollable-container');
     //if (container) container.scrollTop = 0;

    //一进来获取数据地址去掉浏览器路径#后面的数值，包含#

  },
  mounted() {
  // 动态计算导航栏高度
  this.$nextTick(() => {
    const headerHeight = document.querySelector('.headerbox').offsetHeight || 70;
    this.offset = headerHeight + 20;
    window.scrollTo(1, 0);
    
    window.addEventListener('scroll', this.handleScroll);
    
    // 初始更新
    this.updateActive();
    
    // 再次确保（处理可能的渲染延迟）
    setTimeout(() => {
      this.updateActive();
    }, 300);
    });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    if (this.scrollTimer) clearTimeout(this.scrollTimer);
  },
  methods:{
scrollTo(id) {
  this.isScrolling = true;
  this.activeId = id;
  this.currentSectionId = id;
  
  this.$nextTick(() => {
    let targetElement = null;
    
    // 根据ID类型确定目标元素
    if (id === "0") {
      // 热门推荐
      targetElement = this.$refs.hotSection.$el || this.$refs.hotSection;
    } else {
      // 分类区域
      const index = this.leftnavdata.findIndex(item => item.id === id);
      if (index === -1) {
        console.warn(`ID ${id} not found in leftnavdata`);
        this.isScrolling = false;
        return;
      }
      
      const categorySections = this.$refs.categorySections;
      if (!categorySections) {
        console.warn('Category sections not found');
        this.isScrolling = false;
        return;
      }
      
      const section = Array.isArray(categorySections) ? categorySections[index - 1] : categorySections;
      if (!section) {
        console.warn(`Section at index ${index - 1} not found`);
        this.isScrolling = false;
        return;
      }
      
      targetElement = section.$el || section;
    }
    
    if (!targetElement) {
      console.warn('Target element not found');
      this.isScrolling = false;
      return;
    }
    
    const rect = targetElement.getBoundingClientRect();
    const targetPosition = window.pageYOffset + rect.top - this.offset;
    
    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
    
    if (this.scrollTimer) clearTimeout(this.scrollTimer);
    this.scrollTimer = setTimeout(() => {
      this.isScrolling = false;
      this.updateActive();
    }, 600);
  });
},
    // 滚动监听 - 修复版
handleScroll() {
  // 清理之前的定时器或动画帧
  if (this.scrollTimer) {
    window.cancelAnimationFrame(this.scrollTimer);
    this.scrollTimer = null;
  }
  
  // 使用requestAnimationFrame确保在下一帧执行
  this.scrollTimer = window.requestAnimationFrame(() => {
    if (!this.isScrolling) {
      this.updateActive();
    }
  });
},
// 更新高亮状态 - 修复版
updateActive() {
  // 合并所有section引用
  const hotSection = this.$refs.hotSection;
  const categorySections = this.$refs.categorySections || [];
  
  const allSections = [];
  if (hotSection) allSections.push(hotSection);
  if (Array.isArray(categorySections)) {
    allSections.push(...categorySections);
  } else if (categorySections) {
    allSections.push(categorySections);
  }


  if (allSections.length === 0) {
    console.debug('No sections found for active tracking');
    return;
  }

  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const viewportHeight = window.innerHeight;

  if(scrollTop>50){
    this.istop=true;
  }else{
    this.istop=false;
  }

  //console.log('scrollTop',scrollTop);
  
  // 查找当前可见的section
  //this.currentSectionId = null;
  
  // 查找当前可见的section
  for (let i = 0; i < allSections.length; i++) {
    const section = allSections[i];
    const el = section.$el || section;
    
    if (!el || !el.id) continue;
    
    const rect = el.getBoundingClientRect();
    const top = rect.top;
    const bottom = rect.bottom;
    
    // 调整阈值以适应热门推荐区域
    const adjustedThreshold = el.id === "0" ? 50 : this.threshold;
    const isVisible = top <= viewportHeight - adjustedThreshold && bottom >= adjustedThreshold;
    
    if (isVisible) {
      this.currentSectionId = el.id;
      break;
    }
    
    // 如果没有完全可见的，选择最接近视口顶部的
    if (top > 0 && (!this.currentSectionId || top < (document.getElementById(this.currentSectionId).getBoundingClientRect().top || Infinity))) {
      this.currentSectionId = el.id;
    }
  }
  
  // 如果滚动到页面顶部，激活热门推荐（如果存在）
  if (scrollTop < 50) {
    if (hotSection) {
      this.currentSectionId = "0";
    } else if (allSections.length > 0) {
      const firstEl = allSections[0].$el || allSections[0];
      this.currentSectionId = firstEl.id;
    }
  }
  
  // 更新activeId
  if (this.currentSectionId !== null && this.currentSectionId !== this.activeId) {
    this.activeId = this.currentSectionId;
    //this.currentSectionId = currentSectionId;
  }

},
 
    //顶部导航选择
    gotopnav(index){
      //console.log('index',index);

    //   this.$nextTick(() => {
    //     const inkBall = document.querySelector('.ivu-anchor-ink-ball');
    //     if (inkBall) {
    //       inkBall.style.top = '8px';
    //     }
    //  });


      

      // this.oslist = [];
      // this.leftnavdata = [];
      // this.fetchController.abort();
      // this.fetchController = null;
      //this.fullscreenLoading = true;
      // this.dqon = index;
      // this.mainindex = index;
      
      //获取左边分类
      // this.leftnavdata = this.mcdata[this.mainindex].tbmslist;
      // this.mainclassid = this.mcdata[this.mainindex].id;

      //通过子类获取应用
      // this.getosdata();
      // this.gogetselectmainhotpick();


      

    },

    handlephMouseEnter(id){
      this.dqphid = id;
      this.showhotcover = true;
    },
    handlephMouseLeave(){
      this.dqphid = "";
      this.showhotcover = false;
    },
    gogetmainclass(){
      var page=1,
        pageSize=20

      getmainclass(page,pageSize).then(res=>{
        console.log('res',res)
        this.mcdata = res.data.rows;
        //获取左边分类
        this.leftnavdata = res.data.rows[this.mainindex].tbmslist;
        this.leftnavdata.unshift(this.adarr);
        this.mainclassid = res.data.rows[this.mainindex].id;        
        //通过子类获取应用
        this.getosdata();
        this.gogetselectmainhotpick();
        

      })
    },
    gotobiaoqianlist(initial){
      console.log('initial',initial)
      this.$Loading.start();
      this.$router.push({
        name:'biaoqianlist',
        query:{
          initial
        }
      })
      
    },

    //获取热门推荐
    gogetselectmainhotpick(){
      var mainclassid = this.mainclassid;
      getselectmainhotpick(mainclassid).then(res=>{
        console.log('res',res);
        this.hotpicklist = res.data;
      })
    },


    //通过子类获取应用
    async getosdata(){
      var that = this;
      var leftnavdata = this.leftnavdata;  
      this.currentSectionId = this.leftnavdata[0].id;    
      console.log('this.currentSectionId--------------',this.currentSectionId);
      //this.shouldCancel = false; // 初始化取消标志
      // 创建新的 AbortController
      const controller = new AbortController();
      this.fetchController = controller; // 保存引用以便取消
      console.log('leftnavdata',leftnavdata);

      try{
      
        const osarr = [];
          for(const item of this.leftnavdata){

           // 检查是否已被取消
          if (controller.signal.aborted) {
            break;
          }

            var subclassid = item.id;

            const res = await that.getselectos(subclassid);

            console.log('item.id------------',item.id);

            //console.log('res999911110',res);

            osarr.push({
                name:item.name,
                oslist:res.data,
                id:item.id
              });  
            
              this.oslist = osarr;
            
          };

        
        //console.log('osarr----',osarr);
        
        this.fullscreenLoading = false;

        // 数据加载完成后，等待DOM更新
        await this.$nextTick();
        // 强制更新一次active状态
        this.updateActive();

      }catch (error) {
        console.error('获取数据失败:', error);
      }


    },
    getselectos(subclassid){ 
      return getsubclassselectos(subclassid).then(res=>{
          console.log('res9999',res);
          return res;          
      }) 
    },

    goosid02(id){
              
          getappdetail(id).then(res=>{
            console.log('res',res);
            var width = 1380;
            const height = 900
            // 计算居中位置
            const left = (window.screen.width - width) / 2;
            const top = (window.screen.height - height) / 2 - 50;

            

            var osurl = res.data.rows[0].osurl;
            console.log('osurl',osurl);
            window.open (osurl, 'newwindow', `width=${width},height=${height},left=${left},top=${top}, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no`) 
//写成一行 
            //this.ositemlist = res.data.oslist;
          })

   },  
    
    gotolabeldetails(){
      this.$Loading.start();
      this.$router.push({
        name:'labeldetails'
      })
      this.$Loading.finish();
    },
    gotoconact(){      
      this.dqon = 3;
      this.$router.push({
        name:'contact'
      })
    },
    gotoindexbiaoqian(){
      this.dqon = 0;
      this.$router.push({
        name:'index'
      })
    }
  }
};
</script>

<style lang="scss" scoped>

.mainbox{ padding-top: 0px; background: #f5f5f5; min-height: 1000px; min-width: 1320px;}

html,
body {
  height: 100%;
}
.leftbox {
  height: 100%;
  float: left;
  width: 220px;
  padding-right: 10px;
  .leftboxmain {
    padding-left: 50px;
    padding-top:46px;
    font-size: 16px;

    .zimubox {
      background: #f8f8f8;
      width: 40px;
      padding-top: 10px;
      padding-bottom: 10px;
      border-radius: 30px;
      font-size: 13px;
      margin-top: 15px;
    }
  }
}
.rightbox {
  width: 100%;
  padding-top: 25px;

  .rightmainbox {
    padding-left: 250px;

    ul.meitianul li {
      float: left;
      width: 19%;
      max-width: 355px;
      margin-right: 10px; cursor: pointer; position: relative;

      .photcover{ position: absolute; left: 0; top: 0; width: 100%; height: 100%; background:rgba(0,0,0,0.3);}

      .phshiyongbtn{
        display:line-block; text-align: center; z-index: 5;  left: 45%; top:40%; width: 50px; height: 30px; position: absolute; color: #fff; border-radius: 20px; background: rgba(39,196,47,0.8) !important; line-height: 30px; padding: 0 !important;
      }
    }

    .dailyanlibox {
      background: #fff; padding-left: 30px;
      overflow: hidden; margin-right: 20px; border-radius: 10px; padding-bottom:30px;
      h2 {
        font-size: 18px;
        padding-top: 20px;
        padding-bottom: 20px;
        font-weight: normal;
      }
      .dailylistbox {
        overflow: hidden;
        .alimgbox { 
            max-height: 180px; overflow: hidden;
          img {
            
            width: 100%;
          }
        }
        .alimgname {
          padding-top: 8px;
          dl {
            display: flex; justify-content: left; align-items: center;
            dt {
              
              min-width: 50px; width: 50px;
              img {
                border-radius: 50%;
                width: 100%;
                margin-top: 8px;
              }
            }

            dd {
              margin-left: 10px;
              width: 80%;
              h5 {
                font-size: 15px;
                font-weight: normal;
                color: #333;
              }
              p {
                color: #999;
                overflow: hidden;
                text-overflow: ellipsis;
                /*-webkit-text-overflow:ellipsis;*/
                white-space: nowrap;
              }
            }

            @media screen and (max-width: 1380px) {
              /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
              dd {
                float: left;
                width: 70%;
                h5 {
                  font-size: 15px;
                  font-weight: normal;
                  color: #333;
                }
                p {
                  color: #999;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  /*-webkit-text-overflow:ellipsis;*/
                  white-space: nowrap;
                }
              }
            }
          }
        }
      }
    }

    .fenleibiaoti {
      h2 {
        font-size: 18px;
        padding-top: 35px;
        padding-bottom: 25px;
        font-weight: normal;
      }
    }

    .fenleimain {
      box-shadow: 0 0 3.5px #ddd;
      max-width: 1480px; width:93.5%;
      
      .indexcell {
        table {
          width: 100%;
          border-collapse: collapse;
          thead {
            background: #f6f8f9;
            line-height: 60px; cursor: pointer;
            em{ float:right; color: #ccc; font-size: 18px; padding-right: 20px;}
            b {
              display: inline-block;
              height: 15px;
              width: 3px;
              background: #505050;
            }
            span {
              font-size: 18px;
              margin-right: 10px;
              i {
                padding-left: 20px;
                font-size: 20px;
              }
            }
          }
          tbody { background: #fff;
            tr td {
                ul li{
                     cursor: pointer;width:20%;float: left; height: 95px; line-height: 95px; text-align: center; border: 1px solid #f3f3f9;border-left: none; border-top: none; font-size: 15px;
                }                
                ul li:last-child{ }
                ul li:first-child{ border-left: none;}

                ul li:hover{ box-shadow: 0 0 8px #ddd;}

                @media screen and (max-width: 1420px) {  
                    /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
                    ul li {
                        width:25%;
                    }
                } 


            }
          }
        }
      }
    }

     @media screen and (min-width:1470px) and (max-width: 1840px) {
           .fenleimain {
             width:92.5%;
           }
       }

     @media screen and (max-width: 1220px) {  
        /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
        .fenleimain {
             width:94%;
        }
     }  

  }
}

.newword {
  display: inline-block;
  margin-left: 5px;
  width: 20px;
  line-height: 20px;
  background: #11be04;
  color: #fff; text-align: center;
}
.hotword {
  display: inline-block;
  margin-left: 5px;
  width: 20px;
  line-height: 20px;
  background: #ff0030;
  color: #fff; text-align: center;
}

.footerbox {
  height: 60px;
}


.addwebbox{ right:30px; position: fixed; top:38%;cursor: pointer;}
@media screen and (max-width: 1300px) {  
  .addwebbox {
    right: 15px;
    position: fixed;
    top: 38%;
  }
}

>>> .ivu-anchor-ink:before {
  background-color: #fff; width: 0;
}
>>> .ivu-anchor-ink-ball {
  width: 18px;
  border-radius: 0;
  background-color: #27c42f;
  border: 0 #fff solid;
  height: 3px;
  margin-top: 3px;
}

>>> .ivu-anchor-link-active>.ivu-anchor-link-title{color: #27c42f;}
>>> .ivu-anchor-link >.ivu-anchor-link-title:hover{color: #27c42f;}
.ivu-anchor-link{ margin-bottom: 10px;}
.vertical-center-modal{
        display: flex;
        align-items: center;
        justify-content: center;

        .ivu-modal{
            top: 0;
        }
    }

.upimgdl{
  dt{ float: left;}
  dd{ float: left; font-size: 12px; padding-left: 15px; color: #888;}
}

.webaddbox{
  padding-left: 10px; padding-right: 10px;
}



.headerbox {
  min-width:1320px;
  height: 70px; box-shadow: 0 0 5px #ccc;width: 100%;z-index: 50;
  background: #fff;//background: #01a6ff; 
  em{float: right; font-style: normal; font-size:15px; cursor: pointer; color: #333; padding-right:55px; padding-top:20px;}

  .navleftbox{
      .logo{ width: 235px;
           display: flex; float: left; cursor: pointer;
           align-items: flex-start;padding-top:8px; padding-left:43px; padding-right: 25px;
           img{ width: 164px;}
      }
      .navdl{ float: left; padding-left: 20px;
        dt{float: left; font-size:16px; color: #333; text-align: center; line-height: 60px; height: 60px; cursor: pointer; margin-left: 55px;}
        dt.active{border-bottom: 3px solid #27c42f; font-weight: bold;}
        dd{ float: left; margin-top: 12px; position: relative; margin-left: 30px;
          input{
            width: 230px; height: 37px; border: 1px solid #ddd; border-radius: 30px;
            text-indent: 20px; font-size: 13px; outline: none;transition:0.5s;
          }
          .addinput{
            width: 300px; height: 37px; border: 1px solid #ddd;  border-radius: 30px;
            text-indent: 20px; font-size: 13px; outline: none;
          }
          span{ position: absolute; right: 15px; top:0px; font-size:22px; color: #666; cursor: pointer;}
         
        }
      }
  }
 
}



@import "../../assets/css/common.css";



</style>
<style>
.ivu-loading-bar-inner-color-primary{ background-color: #ffa200;}
</style>




// WEBPACK FOOTER //
// src/components/pages/student.vue